<template>
  <div id="app">
    <router-view />
    <div class="empty"></div>
  </div>
</template>

<script>
// import TrackManager from "@/lib/trackManager";

export default {
  name: "App",
  created: function() {
    //微信jssdk
    // url中携带？forcesessionid=xxx时，使用该sessionid，不去重新登录（PDF生成页面，直接服务器调用页面来生成PDF）
    let forcesessionid = this.$util.getUrlQuery('forcesessionid');
    console.log('forcesessionid', forcesessionid);


    // if(!forcesessionid&&this.$util.isIos()){
    //   // 暂时不需要微信登陆
    //   this.$util.useJsdK();  
    // }
  },
  mounted() {
    document.body.addEventListener("touchstart", function() {}); //触发ios端的:active伪类样式
     // 友盟统计配置
    // TrackManager.init();
  },
  watch: {
    // '$route' () {
    //   // TrackManager.trackRoute();
    // }
  },
  components: {
    // Loading
  },
  methods: {
    // handleForWx(){
    //   let currentUrl = window.location?window.location.href.split('#')[0]:'';
    //   if(1||this.$util.isWeiXin()&&this.$util.isIos()){
    //     this.$store.dispatch('setFirstUrl',currentUrl);
    //   }
    // }
  }
};
</script>
<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.clearfix:after{content:"\200B";display:block;height:0;clear:both}
.active-btn{
  cursor: pointer;
  user-select: none;
}
.active-btn:active{
  opacity: 0.8;
}
// 更改dialog按钮默认高亮颜色
.cube-dialog-btn_highlight {
  color: #008aff !important;
}
.btn-scale-animate{
    animation: btn-scale 1s ease-in-out infinite reverse;
}
.btn-scale-animate2{
    animation: btn-scale2 1s ease-in-out infinite reverse;
}
.btn-scale-animate3{
    animation: btn-scale2 .5s ease-in-out infinite reverse;
}
@keyframes btn-scale{
    0%{
        transform: scale(1);
    }
    50%{
        transform: scale(1.1);
    }
}
@keyframes btn-scale2{
    0%{
        transform: scale(1);
    }
    50%{
        transform: scale(1.2);
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue